import React, { Component } from 'react'
import ModificaPasswordSteps from '../Routes/ModificaPasswordSteps';

import { Box, /*Paragraph,*/ Text, /*TextInput, Button*/ } from 'grommet';

export default class InserisciVecchiaPassword extends Component {
    /*Useless constructor since we are not using "this"
    constructor(props) {
        super(props);
    }*/

    render() {

        return (
            <Box className='contentbox' style={{ width: '100%' }}>

                <Box direction="column" align='center'  style={{ width: '100%' }}>
                    <Text className='titlehome' style={{ textAlign:'center', marginBottom: '20px' }}>La tua vecchia password è scaduta. Aggiornala!</Text>
                    <ModificaPasswordSteps align='center' style={{ width: '100%' }}/>
                </Box>
            </Box >
        )
    }
}
